import React from 'react';
import { Body1 } from '@xo-union/tk-ui-typography';
import { DonutChart, DonutChartProps } from '../DonutChart';
import { ChartLegend } from '../ChartLegend';
import styles from '../styles.scss';

interface ChartCardProps extends DonutChartProps {
  title?: string;
}

export const ChartCard: React.FC<ChartCardProps> = ({
  id,
  data,
  label,
  value,
  colors,
  title = 'Will you be attending?',
  children,
}) => {
  return (
    <div className={styles.optionAnswerCardContainer}>
      <Body1 bold className={styles.question}>
        {title}
      </Body1>

      <DonutChart id={id} data={data} value={value} label={label} colors={colors}>
        {children}
      </DonutChart>
      <ChartLegend statsStructures={data} />
    </div>
  );
};
